import { forwardRef, InputHTMLAttributes } from 'react'

import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

interface AddressInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error: string | undefined
  className?: string
  placeholder?: string
  postFix?: React.ReactNode
  label?: string
}

export const AddressInput = forwardRef<HTMLInputElement, AddressInputProps>(
  ({ error, postFix, label, placeholder, className, ...rest }, ref) => {
    return (
      <div className="flex flex-col gap-2">
        {label && <div className="typography-label-3 text-secondary">{label}</div>}
        <div
          className={cn(
            'grid min-h-14 grid-cols-[1fr_auto] gap-2',
            'typography-label-1 sm:typography-label-2 text-primary',
            'rounded-sm border border-primary bg-secondary',
            'focus-within:border-brand-primary',
            'items-center rounded-sm pl-3 sm:pl-4',
            'cursor-text',
            error && 'border-error-200 bg-system-error-primary',
            className,
          )}
          onClick={(e) => {
            if (!(e.target as HTMLElement).closest('button')) {
              e.currentTarget.querySelector('input')?.focus()
            }
          }}
        >
          <input
            className={cn('flex w-full focus:outline-hidden')}
            maxLength={42}
            ref={ref}
            placeholder={placeholder}
            type="text"
            inputMode="text"
            data-testid={testIds.component.AddressInput.input}
            {...rest}
          />
          {postFix}
        </div>
        {error && (
          <div
            className="typography-label-4 text-system-error-primary"
            data-testid={testIds.component.AddressInput.error}
          >
            {error}
          </div>
        )}
      </div>
    )
  },
)
AddressInput.displayName = 'AddressInput'
